import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/EmotionsPageSection.css';

const EmotionsPageSection = () => {
  const { t } = useTranslation();
  
  return (
    <section className="emotions-page-section">
      <div className="emotions-container">
        <div className="emotions-header">
          <h2 className="emotions-title"><span>{t('moreThanCute.emotions')}</span></h2>
          <p className="emotions-description">
            {t('moreThanCute.hasEmotions')}
          </p>
        </div>
        
        <div className="emotions-grid">
          <div className="emotion-item emotion-upset">
            <div className="emotion-image">
              <img src="/images/page13/upset.png" alt="Upset BOBO" />
            </div>
            <span className="emotion-label">{t('moreThanCute.emotionLabels.upset')}</span>
          </div>
          
          <div className="emotion-item emotion-love">
            <div className="emotion-image">
              <img src="/images/page13/love.png" alt="Love BOBO" />
            </div>
            <span className="emotion-label">{t('moreThanCute.emotionLabels.love')}</span>
          </div>
          
          <div className="emotion-item emotion-cute">
            <div className="emotion-image">
              <img src="/images/page13/cute.png" alt="Cute BOBO" />
            </div>
            <span className="emotion-label">{t('moreThanCute.emotionLabels.cute')}</span>
          </div>
          
          <div className="emotion-item emotion-normal">
            <div className="emotion-image">
              <img src="/images/page13/normal.png" alt="Normal BOBO" />
            </div>
          </div>
          
          <p className="emotion-normal-description">
            {t('moreThanCute.hasEmotions')}
          </p>
          
          <div className="emotion-item emotion-angry">
            <div className="emotion-image">
              <img src="/images/page13/angry.png" alt="Angry BOBO" />
            </div>
            <span className="emotion-label">{t('moreThanCute.emotionLabels.angry')}</span>
          </div>
          
          <div className="emotion-item emotion-error">
            <div className="emotion-image">
              <img src="/images/page13/error.png" alt="Error BOBO" />
            </div>
            <span className="emotion-label">{t('moreThanCute.emotionLabels.error')}</span>
          </div>
          
          <div className="emotion-item emotion-happy">
            <div className="emotion-image">
              <img src="/images/page13/happy.png" alt="Happy BOBO" />
            </div>
            <span className="emotion-label">{t('moreThanCute.emotionLabels.happy')}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmotionsPageSection; 